'use strict';

var angular = require('angular');
var dependencies = ['AVRO.Widgets.Combobox', 'AVRO.Widgets.MultiSelectCombobox', 'AVRO.Common.Configuration'];
module.exports = angular.module('AVRO.DemandTransparency.QuickFilter', dependencies).controller('QuickFilterController', require('./controllers/QuickFilterController')).directive('rmQuickFilter', require('./directives/QuickFilterDirective'));